import { useCallback, useMemo } from "react"
import StringUtil from "../../utils/StringUtils"

type Props = {
  selected: string
  onChange: (s: string) => void
}

/**
 * 日付選択
 */
const DateSelector: React.FC<Props> = ({ onChange, selected }) => {
  const dateArray = useMemo(() => selected.split("-"), [selected])

  const handleChangeSelect = useCallback(
    (key: number) => (e: React.ChangeEvent<HTMLSelectElement>) => {
      const copiedArray = [...dateArray]
      copiedArray[key] = e.target.value
      const str = `${copiedArray[0]}-${copiedArray[1]}-${copiedArray[2]}`
      onChange(str)
    },
    [dateArray, onChange],
  )

  /** 年のセレクトボックスの描画 */
  const renderYearSelect = useCallback(() => {
    const items: JSX.Element[] = []
    let year = 1920
    for (let i = 0; i < 101; i++) {
      items.push(
        <option key={year} value={year}>
          {year}年
        </option>,
      )
      year++
    }

    return <>{items}</>
  }, [])

  /** 月のセレクトボックスの描画 */
  const renderMonthSelect = useCallback(() => {
    const items: JSX.Element[] = []
    let month = 1
    for (let i = 0; i < 12; i++) {
      const str = StringUtil.zeroPadding(month)
      items.push(
        <option key={str} value={str}>
          {str}月
        </option>,
      )
      month++
    }

    return <>{items}</>
  }, [])

  /** 日のセレクトボックスの描画 */
  const renderDateSelect = useCallback(() => {
    const items: JSX.Element[] = []
    let date = 1
    for (let i = 0; i < 31; i++) {
      const str = StringUtil.zeroPadding(date)
      items.push(
        <option key={str} value={str}>
          {str}日
        </option>,
      )
      date++
    }

    return <>{items}</>
  }, [])

  return (
    <div className="p-birthSelect">
      <span className="p-birthSelect-select c-select-primary">
        <select
          value={dateArray[0]}
          className="p-birthSelect-select-body c-select-primary-body"
          onChange={handleChangeSelect(0)}
        >
          {renderYearSelect()}
        </select>
      </span>
      <span className="p-birthSelect-select c-select-primary">
        <select
          value={dateArray[1]}
          className="p-birthSelect-select-body c-select-primary-body"
          onChange={handleChangeSelect(1)}
        >
          {renderMonthSelect()}
        </select>
      </span>
      <span className="p-birthSelect-select c-select-primary">
        <select
          value={dateArray[2]}
          className="p-birthSelect-select-body c-select-primary-body"
          onChange={handleChangeSelect(2)}
        >
          {renderDateSelect()}
        </select>
      </span>
    </div>
  )
}

export default DateSelector
